export default {
  apiKey: "AIzaSyBOeYt3eubF7JAzp9mNFcXZ5msmWzsnl1E",
  authDomain: "test-je-werkgeluk-acc-5213b.firebaseapp.com",
  databaseURL: "https://test-je-werkgeluk-acc-5213b.firebaseio.com",
  projectId: "test-je-werkgeluk-acc-5213b",
  storageBucket: "test-je-werkgeluk-acc-5213b.firebasestorage.app",
  messagingSenderId: "189520909666",
  appId: "1:189520909666:web:dbed6de2c1383d771f083b",
  measurementId: "G-LQEBTNV51X",
  appCheckSiteKey: "6LeJCKMtAAAAAD4j9cBY0q0Ii37Cq5yf8grSZpht"
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfigAcc.js